//#region ImportSection
import React, { useEffect, useState } from "react";
import ApiHabibProgress from "../../config/habibprogress/ApiHabibProgress";
import "moment/locale/ur"; // Locale for Urdu month names
import { isUrdu, LoadingSpinner } from "../../../constants/const";
//#endregion ImportSection
const ViewPrgressComments = ({ memberId }) => {
  //#region declareStates
  const [progressResult, setprogressResult] = useState([]);
  const gitsvg = (
    <svg
      aria-hidden="true"
      focusable="false"
      className="octicon octicon-git-commit Octicon-sc-9kayk9-0"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill="currentColor"
      style={{
        display: "inline-block",
        verticalAlign: "text-bottom",
        overflow: "visible",
      }}
    >
      <path d="M11.93 8.5a4.002 4.002 0 0 1-7.86 0H.75a.75.75 0 0 1 0-1.5h3.32a4.002 4.002 0 0 1 7.86 0h3.32a.75.75 0 0 1 0 1.5Zm-1.43-.75a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0Z"></path>
    </svg>
  );

  const styles = `
      .progress-container-scoped { padding-top: 20px; }
      .progress-item-scoped { position: relative; padding-left: 45px; padding-bottom: 15px; }
      .progress-item-scoped::before { content: ''; position: absolute; left: 19px; top: 5px; width: 2px; height: 100%; background-color: #e9ecef; z-index: 0; }
      
      /* MODIFIED: This rule now correctly shortens the line on the last item instead of hiding it */
      .progress-item-scoped:last-child::before {
        height: calc(100% - 40px); /* Calculate height to stop before bottom padding */
      }
  
      .progress-icon-scoped { position: absolute; left: 0; top: 0; background-color: #ffffff; border: 2px solid #ced4da; border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; z-index: 1; }
      .progress-icon-scoped svg { width: 20px; height: 20px; color: #495057; }
      .progress-header-scoped { display: flex; flex-direction: column; align-items: flex-start; 
        
        /* MODIFIED: Reduced bottom margin for tighter spacing */
        margin-bottom: 8px; 
        padding-left:10px;
      }
      .progress-title-scoped { font-size: 28px; font-weight: 600; line-height: 1.1; }
      .progress-date-scoped { font-size: 14px; margin-left: 0; margin-top: 4px; color: #6c757d; }
      
      /* MODIFIED: Removed top margin to rely solely on header's bottom margin */
      .comments-section-scoped { 
        margin-top: 0; 
      }
      
      .comment-card-scoped { background-color: #f8f9fa; border: 1px solid #dee2e6; border-radius: 8px; padding: 16px; margin-bottom: 12px; box-shadow: 0 1px 3px rgba(0,0,0,0.03); }
      .comment-text-scoped { font-size: 16px; margin: 0 0 12px 0; color: #212529; }
      .comment-meta-scoped { font-size: 13px; color: #555; font-style: italic; }
      .comment-author-scoped { font-weight: bold; }
    `;
  //#endregion declareStates
  const [loading, setLoading] = useState(false);

  //#region useEffects
  useEffect(() => {
    if (!memberId) return;
    setLoading(true);

    ApiHabibProgress()
      .GetHabibProgressComments({
        habibId: memberId,
      })
      .then(function (res) {
        setprogressResult(res.data || []);
        setLoading(false);
      })
      .catch(() => {
        setprogressResult([]);
        setLoading(false);
      });
  }, [memberId]);
  //#endregion useEffects
  return (
    <>
      {!loading ? (
        <>
          <style>{styles}</style>

          {progressResult.map((item, index) => (
            <div className="progress-item-scoped" key={item.id || index}>
              <div className="progress-icon-scoped">{gitsvg}</div>
              <div className="progress-header-scoped">
                <span
                  className={`progress-title-scoped ${
                    isUrdu(item.progressName) ? "ur" : ""
                  }`}
                >
                  {item.progressName}
                </span>
                <span className="progress-date-scoped">
                  <i>
                    {new Date(item.fromDate)
                      .toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })
                      .replace(/(\d{2}) (\w{3}) (\d{4})/, "$1 $2, $3")}
                  </i>
                </span>
              </div>
              <div className="comments-section-scoped">
                {item.comments.map((comment, commentIndex) => (
                  <div
                    className="comment-card-scoped"
                    key={comment.id || commentIndex}
                  >
                    <p
                      className={`comment-text-scoped ${
                        isUrdu(comment.comment) ? "ur" : ""
                      }`}
                    >
                      {comment.comment}
                    </p>
                    <p className="comment-meta-scoped">
                      💬 By{" "}
                      <span
                        className={`comment-author-scoped ${
                          isUrdu(comment.commentBy) ? "ur" : ""
                        }`}
                      >
                        {comment.commentBy}
                      </span>
                      🕒 On{" "}
                      {new Date(comment.createdAt)
                        .toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                        .replace(/(\d{2}) (\w{3}) (\d{4})/, "$1 $2, $3")}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </>
      ) : (
        LoadingSpinner()
      )}
    </>
  );
};

export default ViewPrgressComments;
